'use client'

import { useState } from 'react'
import { Combobox } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'

import numbers from './codephones.json'

export default function CodePhoneCombo() {
  const [query, setQuery] = useState('')

  const filteredNumbers =
    query === ''
      ? numbers
      : numbers.filter((person) =>
          person.label.toLowerCase().includes(query.toLowerCase())
        )

  return (
    <Combobox
      name="phone-code"
      defaultValue={numbers.find((number) => number.label === 'AR')?.code}
    >
      <div className="relative w-full cursor-default rounded-lg bg-white text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm">
        <Combobox.Input
          required
          pattern="^[a-zA-Z]{2}$"
          placeholder=" "
          onChange={(event) => setQuery(event.target.value)}
          displayValue={(value) => {
            return numbers.find((number) => number.code === value)?.label || ''
          }}
          className="peer block w-full rounded-md border border-transparent px-3.5 py-2 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 invalid:[&:not(:placeholder-shown):not(:focus)]:border-red-500"
        />
        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
          <ChevronDownIcon
            className="h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </Combobox.Button>
        <Combobox.Options className="peer absolute top-10 mt-2 max-h-48 w-full overflow-y-auto rounded-md border border-transparent bg-white shadow-md placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          {filteredNumbers.map((number) => (
            <Combobox.Option
              key={number.label}
              value={number.code}
              className="cursor-pointer  px-3.5 py-2 hover:bg-brand-pink"
            >
              {number.label}
            </Combobox.Option>
          ))}
        </Combobox.Options>
      </div>
    </Combobox>
  )
}
